import { c as create_ssr_component, d as add_attribute, e as escape, v as validate_component } from "../../../../chunks/ssr.js";
import { T as TextBoxEditOutline, C as CurrencyUsd, P as PlusThick, a as Shield, B as BookOpenPageVariant, H as Headset, b as Tablet, c as Sync, S as ServicePageTemplate } from "../../../../chunks/ServicePageTemplate.js";
import { A as AccountCowboyHatOutline } from "../../../../chunks/AccountCowboyHatOutline.js";
import { C as ClipboardEdit } from "../../../../chunks/ClipboardEdit.js";
import { T as Turbine } from "../../../../chunks/Turbine.js";
import { C as CheckDecagram } from "../../../../chunks/CheckDecagram.js";
import { C as CopyCard } from "../../../../chunks/CopyCard.js";
import { S as StdHeading } from "../../../../chunks/Button.js";
const Gold = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M1 22L2.5 17H9.5L11 22H1M13 22L14.5 17H21.5L23 22H13M6 15L7.5 10H14.5L16 15H6M23 6.05L19.14 7.14L18.05 11L16.96 7.14L13.1 6.05L16.96 4.96L18.05 1.1L19.14 4.96L23 6.05Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const _page_svelte_svelte_type_style_lang = "";
const css = {
  code: ".sections_wrapper.svelte-1gzjdlz{padding:50px 0;display:flex;flex-direction:column;align-items:center;gap:70px;overflow:hidden}@media(max-width: 800px){.sections_wrapper.svelte-1gzjdlz{padding:2.5rem 0.5rem}}@media(max-width: 430px){.sections_wrapper.svelte-1gzjdlz{padding:2.5rem 0}}",
  map: null
};
let programs = true;
let pricingPackage = false;
let professionalProgram = false;
let hero_image = "/multi_taxi.webp";
let background_center = true;
let h1 = "Multi Engine Rating Program";
let hero_paragraph_content = "A Multi Engine Rating enables you to serve as the pilot-in-command (PIC) of aircraft equipped with multiple engines. Obtaining this rating is essential for aspiring pilots looking to pursue a career in the airline industry or enhance their skill level which looks great to potential employers in the aviation field, especially when it comes from a school known for its high-quality training.";
let center_img_seperating_section = false;
let second_center_img_seperating_section = false;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let icon_size;
  let roadmap_stages = [
    [
      {
        text: "Multi Engine Orientation",
        icon: AccountCowboyHatOutline
      },
      {
        text: "Multi Engine Training",
        icon: Turbine
      },
      {
        text: "Multi Engine Checkride",
        icon: ClipboardEdit
      },
      {
        text: "Multi Engine Add-on Achieved",
        icon: CheckDecagram
      }
    ]
  ];
  let prerequisites = {
    eligibility: [
      "Be at least 18 years of age",
      "Be English proficient",
      "Hold at least a private pilot certificate",
      "Receive a logbook endorsement from an authorized instructor who conducted the required ground training or reviewed your home study and certified that you are prepared for the required knowledge test",
      "Pass the required knowledge test",
      "Receive the required training and a logbook endorsement from an authorized instructor who conducted the training and certified that you are prepared for the required practical test",
      "Meet the aeronautical experience requirements",
      "Pass the required practical test",
      "Comply with the regulations"
    ],
    proficiency: [
      "Preflight preparation",
      "Preflight procedures",
      "Airport operations",
      "Takeoffs, landings, and go-arounds",
      "Performance maneuvers",
      "Multi-engine operations",
      "Navigation",
      "Slow flight and stalls",
      "Emergency operations",
      "High altitude operations",
      "Post-flight procedures"
    ],
    experience: [
      "Must have a logbook or training record endorsement from an authorized instructor attesting that the person was found competent in the appropriate aeronautical knowledge areas and proficient in the appropriate areas of operation",
      "Must pass the practical test",
      "<b>Note:</b> Expect around 10 hours of training"
    ]
  };
  let things_included = [
    {
      text: "Written Tests",
      icon: TextBoxEditOutline
    },
    {
      text: "Checkride Fees",
      icon: CurrencyUsd
    },
    { text: "FAA Medical", icon: PlusThick },
    { text: "Renter's Insurance", icon: Shield },
    {
      text: "Pilot Training Kits",
      icon: BookOpenPageVariant
    },
    {
      text: "David Clark H10-13.4 Headset",
      icon: Headset
    },
    { text: "Ipad Mini", icon: Tablet },
    {
      text: "Foreflight Subscription",
      icon: Sync
    },
    {
      text: "Books and Materials",
      icon: BookOpenPageVariant
    }
  ];
  let faqs = [
    {
      question: "How to get multi engine rating?",
      answer: "A multi-engine rating is an additional qualification that allows pilots to operate aircraft with multiple engines. To obtain this rating, a pilot typically needs to undergo training and pass a checkride in a multi-engine aircraft. This rating is often sought by those pursuing careers in aviation, especially for jobs where multi-engine aircraft are used.",
      opened: false
    },
    {
      question: "What Materials should I have for this course?",
      answer: "Each course offered requires specific resources that are referenced. Since Aviation has such a high cost, we make every attempt to keep book purchases to a minimum. \n\nEach course of study and their corresponding modules have reading materials and video resources that must be read or watched. If it is a necessity for the course, it will be listed in the Course Resources Module. Students will be sent a Computer Based Training (CBT) link and a training manual, and the CBT course has various tests and quizzes associated with it. We expect students to have finished the CBT and Training References Manual tests prior to arriving for their first class. This pre-study is critical, especially if students have enrolled in the accelerated class. \n\n<b>If students have not completed and passed their pre-study quizzes, then they are unable to be considered an accelerated student. It is likely that some students may need additional instruction not covered in the base cost of the course.</b>",
      opened: false
    },
    {
      question: "What if I have a question, problem or error that needs an instructor’s attention?",
      answer: "If students have questions about the syllabus or training documents, they should email the Chief Pilot. If a question is complex and requires a conversation, then every effort should be made to schedule the meeting via Zoom before the session starts.",
      opened: false
    },
    {
      question: "Can I drop by with questions?",
      answer: "It is best to send your instructor a note via e-mail first. That way you can schedule an appointment that works for both of you. If you decide to drop by the office without an appointment, expect the instructor to be unavailable. They may be teaching a class or preparing a lesson for that day. If you catch them in, they will be more than happy to address your concerns.",
      opened: false
    },
    {
      question: "Are deposits required for training?",
      answer: "Yes, we require a minimum of $1,000 as a deposit to reserve your scheduled training dates. The remainder of the funds are due and payable one (1) week prior to the actual class start date",
      opened: false
    },
    {
      question: "Is the deposit refundable?",
      answer: "No. The $1,000 deposit is non-refundable. Once training has started, any refund will be calculated based on standard rates.",
      opened: false
    },
    {
      question: "What form of payment do we accept?",
      answer: "Cash, Wire or ACH are the preferred payment methods. We will accept credit card charges for the initial deposit. We do not accept online currencies such as BitCoin",
      opened: false
    },
    {
      question: "Are there any surcharges or hidden fees?",
      answer: "There are no hidden fees if the student purchases the “package” price. Some students prefer to “pay as you go” – and any charges are applied immediately after the lesson has been completed \n\n<b>NOTE</b> – all accelerated course students <b>are required</b> to purchase the twin training package.",
      opened: false
    },
    {
      question: "Does the package price cover all training, regardless as to how long it may take?",
      answer: "If the student training exceeds <b>either</b> the instructor or flight time listed in the package price, students will be billed the addition fees at the standard rental / instruction rates.",
      opened: false
    }
  ];
  $$result.css.add(css);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    icon_size = "50%";
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-1lguuzg_START -->${$$result.title = `<title>Multi Engine Rating | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation multi engine pilot training"><!-- HEAD_svelte-1lguuzg_END -->`, ""}  ${validate_component(ServicePageTemplate, "ServicePageTemplate").$$render(
      $$result,
      {
        faqs,
        programs,
        pricingPackage,
        professionalProgram,
        hero_image,
        background_center,
        h1,
        hero_paragraph_content,
        roadmap_stages,
        center_img_seperating_section,
        second_center_img_seperating_section,
        prerequisites,
        things_included
      },
      {},
      {
        two: () => {
          return `<div slot="two">${validate_component(StdHeading, "StdHeading").$$render(
            $$result,
            {
              font_family: "Inter",
              color: "dark",
              size: "small"
            },
            {},
            {
              default: () => {
                return `Why should you get a Multi-Engine Rating?`;
              }
            }
          )} <div class="sections_wrapper svelte-1gzjdlz">${validate_component(CopyCard, "CopyCard").$$render(
            $$result,
            {
              src: "/multi_engine.webp",
              alt: "Tecnam P2006t engine"
            },
            {},
            {
              text: () => {
                return `<div slot="text" data-svelte-h="svelte-b0bt7j">If you begin having engine trouble, your only solution in a single
          engine airplane is to land immediately. With more than one engine, you
          can continue flying toward a more suitable landing spot if you have a
          mechanical problem with an engine.</div>`;
              },
              heading: () => {
                return `<div slot="heading" data-svelte-h="svelte-nbvciw">1) Two engines are (usually) safer than one</div>`;
              }
            }
          )}</div> <div class="sections_wrapper svelte-1gzjdlz">${validate_component(CopyCard, "CopyCard").$$render($$result, { blueBorder: true }, {}, {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-1aq37f6">Most multi-engine airplanes are substantially faster than similarly
          sized single engine counterparts. To complete a trip quickly, consider
          using a multi-engine airplane.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1sdwb4y">2) You’ll fly faster</div>`;
            }
          })}</div> <div class="sections_wrapper svelte-1gzjdlz">${validate_component(CopyCard, "CopyCard").$$render(
            $$result,
            {
              src: "/multi_rollout.webp",
              alt: "Tecnam P2006t landing roll"
            },
            {},
            {
              text: () => {
                return `<div slot="text" data-svelte-h="svelte-1caeu9f">Whether it’s carrying more passengers or more equipment, multi-engine
          airplanes usually have a higher available payload than single engine
          aircraft of similar size. Plus, they look pretty cool on the ramp!</div>`;
              },
              heading: () => {
                return `<div slot="heading" data-svelte-h="svelte-2vuy35">3) How about a size upgrade?</div>`;
              }
            }
          )}</div> <div class="sections_wrapper svelte-1gzjdlz">${validate_component(CopyCard, "CopyCard").$$render($$result, { blueBorder: true }, {}, {
            icon: () => {
              return `<div slot="icon">${validate_component(Gold, "Gold").$$render(
                $$result,
                {
                  color: "#15181C",
                  width: icon_size,
                  height: icon_size
                },
                {
                  width: ($$value) => {
                    icon_size = $$value;
                    $$settled = false;
                  },
                  height: ($$value) => {
                    icon_size = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}</div>`;
            },
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-1og4zh4">In the past, airlines and charter companies have required new hire
          pilots to apply with hundreds of multi-engine flight hours. The hiring
          market is booming right now, and many of those requirements have
          disappeared for the time being, however that won’t be the case
          forever! The more multi-engine time you have, the more competitive
          you’ll be in a hiring market.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1jxkavz">4) Multi-Engine flight time is valuable</div>`;
            }
          })}</div> <div class="sections_wrapper svelte-1gzjdlz">${validate_component(CopyCard, "CopyCard").$$render(
            $$result,
            {
              src: "/multi_peace.webp",
              alt: "Tecnam P2006t peace"
            },
            {},
            {
              text: () => {
                return `<div slot="text" data-svelte-h="svelte-1oxcyv2">According to FAR 61.63(c), there is no minimum time requirement to add
          a multi-engine rating to your pilot certificate under Part 61, and you
          don’t have to take a new FAA written test. After 10-15 hours of flight
          training, your multi-engine instructor can sign you off to take the
          FAA practical test. For many people, a multi-engine add-on can be
          accomplished over just a few weeks. Ask us about our accelerated
          multi-engine training that we have available. Adding an MEL rating
          will make you a better, more confident pilot. Reference the FAA
          Private Pilot or Commercial Pilot ACS to see what your training
          requirements are.</div>`;
              },
              heading: () => {
                return `<div slot="heading" data-svelte-h="svelte-14iwil2">5) Getting a MEL add-on rating is easy</div>`;
              }
            }
          )}</div> <div class="sections_wrapper svelte-1gzjdlz" style="padding-bottom: 0; overflow: visible;">${validate_component(CopyCard, "CopyCard").$$render($$result, { blueBorder: true }, {}, {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-2t8ivg">If you want to be a professional pilot, full time or part time, having
          a multi-engine rating will open the doors to many more job
          opportunities. Many charter companies fly light twins like Cessna 414s
          or King Airs, with clients on board.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-ymsmyo">6) Open up more job opportunities</div>`;
            }
          })}</div></div>`;
        },
        one: () => {
          return `<div slot="one">${validate_component(CopyCard, "CopyCard").$$render(
            $$result,
            {
              src: "/multi_landing.webp",
              alt: "Tecnam P2006t landing"
            },
            {},
            {
              text: () => {
                return `<div slot="text" data-svelte-h="svelte-48kjje">At First Landings Aviation, you’ll train in a well-maintained Tecnam
        P2006t, a 4-seat twin engine airplane equipped for IFR flight. If you do
        not aspire to a career in professional aviation, remember that many
        hobbyist pilots fly multi-engine airplanes for the greater range and
        cargo capabilities as well as the security of flying with a second
        engine.</div>`;
              },
              heading: () => {
                return `<div slot="heading" data-svelte-h="svelte-1kkxrt0">Course Description</div>`;
              }
            }
          )}</div>`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
